// src/components/cardComponents/dialogComponents/DialogComparisonContainer.tsx
import React, { FC, ReactNode } from 'react';
import { styled } from "@mui/system";
import { Grid } from "@mui/material";

interface DialogComparisonContainerProps {
  children: ReactNode;
  className?: string;
}

const StyledContainer = styled(Grid) ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  rowGap: '1em',
  paddingTop: '2em'
})

const DialogComparisonContainer: FC<DialogComparisonContainerProps> = ({
  children,
  className
}) => {
  return (
    <StyledContainer className={className}>
      {children}
    </StyledContainer>
  );
};

export { DialogComparisonContainer };